import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import LocalSettings from 'FormsCommonComponents/utils/LocalSettings';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Patt... Remove this comment to see the full error message
import Url from 'PatternValidationJS/patterns/Url';
const FULL_URL_REGEX = new RegExp(/(http|https?):\/\/[^ "]+$/);
const FORMS_DASHBOARD_REGEX = /^\/forms\/[0-9]+\/?(\?.*)?$/;
export function isFullUrl(url) {
  return FULL_URL_REGEX.test(url);
}
export function isValidUrl(url) {
  return Url.test(url, {
    requireProtocol: true
  });
}
export function navigateTo(url) {
  setTimeout(() => {
    window.location.href = url;
  }, 0);
}
export function isFormsDashboard(url) {
  return FORMS_DASHBOARD_REGEX.test(url);
}
export function isInternalUrl(url) {
  return Boolean(url && url.indexOf('/') === 0);
}
export function isHubSpotUrl(url) {
  return /^http(s)?:\/\/[a-z0-9-]+.hubspot(qa)?.com\//i.test(url);
}
export function getRelativeUrl(url) {
  const el = document.createElement('a');
  el.href = url;
  // prevent external links from being opened
  if (el.pathname.startsWith('//')) {
    return null;
  }
  return `${el.pathname}${el.search}`;
}

// TODO: Update to use new share page
export const getNewFormPreviewUrl = () => {
  const maybeLocal = !enviro.deployed() ? '?local=true' : '';
  if (LocalSettings.get('FORMS_PREVIEW_LOCAL')) {
    return `${getFullUrl('local')}/feedback-survey-preview${maybeLocal}`;
  }
  return `${getFullUrl('app')}/feedback-survey-preview${maybeLocal}`;
};
export const getSearchParamsObj = searchParams => {
  const urlSearchParams = new URLSearchParams(searchParams);
  const obj = {};
  for (const [key, value] of urlSearchParams.entries()) {
    obj[key] = value;
  }
  return obj;
};